import { brandListCallOptions } from '../../../services/brandlist.services';
import { brandSchema } from '../Brands/brands.saga';
import { loadCmsBrands, updateCmsBrandEntities } from './cmsbrands.actions';
import { call, fork, put, take, select } from 'redux-saga/effects';
import { callApi } from '../../api';
import { normalize } from 'normalizr';

export function* fetchAllCmsBrandsForAppId(appId: number) {
  const { ok, data } = yield call(callApi, brandListCallOptions());
  const normalized = normalize(data.data, [brandSchema]);
  if (ok) {
    yield put(
      updateCmsBrandEntities({ appId, brands: normalized.entities.brand })
    );
  }
}

export function* prepareCmsBrands(appId: number) {
  yield fetchAllCmsBrandsForAppId(appId);
}

export function* watchForFetchCmsBrands() {
  yield take(loadCmsBrands.type);
  const {
    storyEdit: { activeAppId },
  } = yield select() as any;

  yield fork(prepareCmsBrands, activeAppId || 139);
}



// WEBPACK FOOTER //
// ./src/store/Entities/CmsBrands/cmsbrands.saga.ts